export default "/images/phone-input-flags@2x.png?1ff49fd4eddddb2bde9f78c2434bb12e";